import { trackDesignerInteraction } from '@utils/gtm'
import { HiArrowsPointingIn } from 'react-icons/hi2'
import { HiOutlineArrowsExpand } from 'react-icons/hi'
import router from 'next/router'
import { useEditorFullScreenMode } from '@pageFeatures/design/UnifiedEditorProvider'
import { useDesignSide, useEditorConfig } from '../EditorDataProvider'
import classNames from 'classnames'
import { TDesignSide } from '../editor.types'

export function TopControlBar({
  changeCanvasSide,
}: {
  changeCanvasSide: (canvasSide: TDesignSide) => void
}) {
  const { isFullScreen, setIsFullScreen } = useEditorFullScreenMode()
  const { activeDesignSide } = useDesignSide()
  const { twoSided } = useEditorConfig()

  return (
    <div className="justify-end pb-6 align-center flex">
      {twoSided && (
        <div className="flex mr-auto text-lg font-mori">
          <button
            className={classNames(
              'flex items-center px-8 pt-4 pb-3 mr-4 bg-white border-2 text-acai hover:bg-pebble border-black-20 rounded-lg h-14 font-semibold',
              {
                'bg-pebble border-black-40': activeDesignSide === 'front',
              }
            )}
            disabled={activeDesignSide === 'front'}
            onClick={() => changeCanvasSide('front')}
          >
            Front
          </button>

          <button
            className={classNames(
              'flex items-center px-8 pt-4 pb-3 mr-4 bg-white border-2 text-acai hover:bg-pebble border-black-20 rounded-lg h-14 font-semibold',
              {
                'bg-pebble border-black-40': activeDesignSide === 'back',
              }
            )}
            disabled={activeDesignSide === 'back'}
            onClick={() => changeCanvasSide('back')}
          >
            Back
          </button>
        </div>
      )}

      {isFullScreen && (
        <div
          className="items-center cursor-pointer text-acai hidden lg:flex"
          onClick={() => {
            setIsFullScreen((fullScreenMode) => !fullScreenMode)
            trackDesignerInteraction({
              event: 'designer-interaction',
              designerName: 'editor',
              componentName: `FullScreenMode`,
              componentInformation:
                'User entered online editor full screen mode',
              selectedProductSlug: router.query?.slug.toString(),
              displayType: 'IconButton',
            })
          }}
        >
          <HiArrowsPointingIn className="w-10 h-10" />
          <div className="flex pl-3 text-lg align-center">Close</div>
        </div>
      )}

      {!isFullScreen && (
        <HiOutlineArrowsExpand
          className="w-10 h-10 cursor-pointer text-acai hidden lg:flex"
          onClick={() => {
            setIsFullScreen((fullScreenMode) => !fullScreenMode)
            trackDesignerInteraction({
              event: 'designer-interaction',
              designerName: 'editor',
              componentName: `ExitFullScreenMode`,
              componentInformation:
                'User exited online editor full screen mode',
              selectedProductSlug: router.query?.slug.toString(),
              displayType: 'IconButton',
            })
          }}
        />
      )}
    </div>
  )
}
